import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { AuthService } from '../../services/auth.service';

import { ICompanyContactLoginByEmail } from '../../models/ICompanyContactLoginByEmail.model';

@Component({
    selector: 'app-activate-account-modal',
    templateUrl: './activate-account-modal.component.html',
    styleUrls: ['./activate-account-modal.component.less']
})
export class ActivateAccountModalComponent {
    private email: string;
    private loginInfo: ICompanyContactLoginByEmail;
    private searched: boolean;
    private resetPasswordAttempt: boolean;
    private resetPasswordSent: boolean;
    private accountNotFound: boolean;

    @ViewChild('activateAccountForm') form: any;

    constructor(
        private _auth: AuthService,
        private _dialogRef: MatDialogRef<ActivateAccountModalComponent>
    ) { }

    activateAccount(): void {
        this._auth.getCompanyContactLoginByEmail(this.email)
            .subscribe(loginInfo => {
                this.loginInfo = loginInfo;
                this.searched = true;
            });
    }

    resetPassword(): void {
        this.resetPasswordAttempt = true;

        this._auth.forgotPassword(this.email)
            .subscribe(response => {
                if (response.email) {
                    this.resetPasswordSent = true;
                } else {
                    this.accountNotFound = true;
                }
            });
    }

    closeDialog(): void {
        this._dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/login/activate-account-modal.component.ts